// app/EDUP_TestColleghi/tests.js

(function () {
    "use strict";
    var controllerId = "testColleghi";
    angular.module("app").controller(controllerId, ["$rootScope", "$scope", "$filter", "$location", "common", "bootstrap.dialog", "$routeParams", "$q", "$uibModal", "datacontext", "sectionMenu", "filterFilter", '$translate', '_', testColleghiFn]);

    function testColleghiFn($rootScope, $scope, $filter, $location, common, bDialog, $routeParams, $q, $uibModal, datacontext, sectionMenu, filterFilter, $translate, _) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, "logError");
        var logSuccess = getLogFn(controllerId, "logSuccess");
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = "TestCondivisi";
        vm.view = "list";       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection('TestCondivisi');

        vm.objName = "test"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;        

        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.readonly = true;

        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.questionsCount = 0;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ["Difficolta'", "Docente", "Materia", "Titolo", "Ultima Modifica"];
        vm.list.ordine = common.setOrdine(vm.list.ordine)
        vm.ordine = vm.list.ordine[4];

        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        //Elenchi dettaglio
        vm.list.questions = [];
        vm.tipoTest = [];
        vm.getRecord = getRecord;
        vm.getListQuestions = getListQuestions;

        //Filtro
        vm.filter = {};
        vm.filter.ricerca = "";
        vm.filter.stato = 0;
        vm.filter.testAllievi = -1;
        vm.fRicerca = "";
        vm.fStato = 0;
        vm.fTestAllievi = -1;
        vm.fIstitutoShare = false;
        vm.fTipologia = 0;
        vm.filter.tipologia = 0;
        vm.fAutore = 0;
        vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        vm.filter.anno = vm.fAnno;

        vm.materie = [];

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;
        vm.getSchedaCompetenze = getSchedaCompetenze;
        vm.modalDetailAC = modalDetailAC;
        vm.setDidatticaAttivo = setDidatticaAttivo;
        vm.setCompBaseAttivo = setCompBaseAttivo;
        vm.createSession = createSession;
        vm.stampaTest = stampaTest;

        vm.selezionaDeselezioneTutto = selezionaDeselezioneTutto;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getMaterie(), getTipoTest()];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.testId != null) {
                            setView("detail");
                            getRecord($routeParams.testId, 0);
                        }
                    });            
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {            
            if (view == 'list') {                
                cerca();
            }
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;            
            vm.filter.ricerca = vm.fRicerca == null ? 0 : vm.fRicerca;
            vm.filter.tipologia = vm.fTipologia == null ? 0 : vm.fTipologia;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            if (vm.fAutore == 0) {
                return datacontext.testCondivisi_countByFilter(vm.filter.ricerca, vm.filter.tipologia, $rootScope.community)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
            } else if(vm.fAutore == 1){
                return datacontext.testCommunity_countByFilter(vm.filter.ricerca, vm.filter.tipologia)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
            } else if (vm.fAutore == 2) {
                return datacontext.testIstituto_countByFilter(vm.filter.ricerca, vm.filter.tipologia)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
            } else {
                return datacontext.testAllieviCondivisi_countByFilter(vm.filter.ricerca, vm.filter.tipologia)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
            }
            
        }

        function getAllByFilter() {            
            if (vm.loading === true) return;
            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            if (vm.fAutore == 0) {
                return datacontext.testCondivisi_getAllByFilter(vm.pageSize, vm.page, vm.filter.ricerca, vm.filter.tipologia, $rootScope.community, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
            } else if(vm.fAutore == 1){
                return datacontext.testCommunity_getAllByFilter(vm.pageSize, vm.page, vm.filter.ricerca, vm.filter.tipologia, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
            } else if (vm.fAutore == 2) {
                return datacontext.testIstituto_getAllByFilter(vm.pageSize, vm.page, vm.filter.ricerca, vm.filter.tipologia, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
            } else {
                return datacontext.testAllieviCondivisi_getAllByFilter(vm.pageSize, vm.page, vm.filter.ricerca, vm.filter.tipologia, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
            }
            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.test_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                //vm.record.DataUltimaModifica = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                vm.record.status = $filter("teststatus")(data.status);
                getSchedaCompetenze().then(function (data) {
                    //Azzera liste
                    vm.list.questions = [];
                    countListQuestions(id);
                    setView("detail");
                });

                //datacontext.tipoTest_get(data.tipoTestId).then(function (data) {
                //    if(data)
                //        vm.record.tipoTest = data.Title;
                //});

                return vm.record;
            });
        }        

        //List Methods
        //Utilizzato nella scheda di dettaglio per disabilitare il tasto crea sessione
        function countListQuestions(id) {
            if (!id) return;
            return datacontext.questionTest_countByTest(id).then(function (data) {
                if (data) {
                    vm.questionsCount = data;
                }
            });
        }

        function getListQuestions(id) {
            if (!id) return;
            return datacontext.questionTest_getAllByTest(id, "sequence").then(function (data) {
                if (data) {
                    vm.assi.CompetenzeChiave.forEach(function (cChiave) {
                        cChiave.CompetenzeBase.forEach(function (cBase) {
                            cBase.qAttivo = true;    //tasto acceso                                                
                            var BreakException = {};
                            try {
                                data.forEach(function (q) {
                                    if (q.CompetenzeBase) {
                                        var check = _.find(q.CompetenzeBase, function (o) {
                                            return o.CompBaseId == cBase.Id && o.Attivo == false;
                                        });
                                        if (check != undefined) {
                                            cBase.qAttivo = false;   //tasto spento                                       
                                            throw BreakException;
                                        }
                                    }
                                });
                            }
                            catch (e) {
                                if (e !== BreakException) throw e;
                            }
                        });
                    });
                }
                return vm.list.questions = data;
            });
        }

        function getMaterie() {
            return datacontext.materia_getAllListComplete().then(function (data) {
                return vm.materie = data;
            });
        }

        function getTipoTest() {
            return datacontext.tipoTest_getAllList().then(function (data) {
                return vm.tipoTest = data;
            });
        }

        function getSchedaCompetenze() {
            return datacontext.schedaCompetenzeTest_getAll(vm.record.Id, $rootScope.id, vm.filter.anno).then(function (compTest) {
                vm.compTest = compTest;

                return datacontext.asseCulturale_get(vm.compTest[0].AsseId).then(function (asse) {
                    asse.CompetenzeChiave.forEach(function (cChiave) {
                        cChiave.CompetenzeBase.forEach(function (cBase) {
                            var check = _.find(vm.compTest, function (o) {
                                return o.CompBaseId == cBase.Id;
                            });
                            if (check) {
                                cBase.Attivo = check.Attivo;
                                cBase.Personalizzazione1 = check.Personalizzazione1;
                                cBase.Personalizzazione2 = check.Personalizzazione2;
                                cBase.Peso = check.Peso;
                            }
                        });
                    });
                    return vm.assi = asse;
                });
            });
        }

        function modalDetailAC(item) {
            var modalDetail = {};
            angular.copy(item, modalDetail);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/didatticaCompetenze/modal/schedaCompetenzeProfiloDetail.html?version=43',
                controller: 'schedaCompetenzeProfiloDetail',
                windowClass: 'modal-wide',
                resolve: {                      // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    schedaCompetenzeDetail: function () {
                        return modalDetail;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                var sc = _.find(vm.compTest, function (o) { return o.CompBaseId == item.Id });
                if (sc && sc.Id && sc.Id > 0) {
                    sc.Personalizzazione1 = returnItem.Personalizzazione1;
                    datacontext.schedaCompetenzeTest_update(sc).then(function (data) {
                        if (data && data.Id && data.Id > 0) {
                            item.Personalizzazione1 = sc.Personalizzazione1;
                            logSuccess($translate.instant('DatoSalvato'));
                        }
                        else
                            logError($translate.instant('ImpossibileSalvareDati'));
                    });
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function setDidatticaAttivo(item) {
            var sc = _.find(vm.compTest, function (o) { return o.CompBaseId == item.Id });
            if (sc && sc.Id && sc.Id > 0) {
                if (item.Attivo)
                    sc.Peso = 100;
                else
                    sc.Peso = 0;

                datacontext.schedaCompetenzeTest_update(sc).then(function (data) {
                    if (!data || !data.Id || data.Id == 0)
                        logError($translate.instant('ImpossibileSalvareDati'));
                });
            }
            else
                logError($translate.instant('ImpossibileSalvareDati'));
        }

        function setCompBaseAttivo(item) {
            item.Attivo = !item.Attivo;
            return datacontext.questionTestCompBase_update(item).then(function (data) {
                getListQuestions(vm.record.Id);//inserito per aggiornare tasto del seleziona tutto
                if (!data || data == null || data.Id == 0)
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function createSession() {
            $location.path('/EDUP_session/' + vm.record.Id + '/create=true');
        }

        function stampaTest(testId) {
            if (!testId)
                testId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/EDUP_Test/modal/stampaTest.html?version=43",
                controller: "stampaTest",
                windowClass: 'modal-wide-print',
                resolve: {
                    testId: function () {
                        return testId;
                    }
                }
            });
        }

        function selezionaDeselezioneTutto(item, value) {
            var msg = "";
            if (value == 1)
                msg = $translate.instant('AvvisoAttivareCompetenza') + " " + item.Codice + " - " + item.CompetenzaBase + "?";
            else
                msg = $translate.instant('AvvisoDisattivareCompetenza') + " " + item.Codice + " - " + item.CompetenzaBase + "?";

            bDialog.confirmationDialog($translate.instant('Conferma'), msg).then(function () {
                return datacontext.questionTestCompBase_updateAll(item.Id, vm.record.Id, value).then(function (data) {
                    getListQuestions(vm.record.Id);
                    logSuccess($translate.instant('DatiSalvati'));
                });
            });
        }
    }
})();
